import { useState } from "react";
import { errorDetails, SmsAccount, SmsHttp, SmsNotify } from "./types";

export interface SmsToolsMessages {
  testSent: string;
  // OTP paketi yokken normal hatta düşüldüğünde test mesajının sonuna eklenir.
  testViaFallback: string;
  testFailed: string;
  balanceFailed: string;
  // Ham NetGSM yanıtını hata metnine ekler.
  rawSuffix: (raw: string) => string;
}

export interface UseSmsToolsOptions {
  http: SmsHttp;
  // Ayar uçlarının bağlandığı yol (ör. "/settings" → /settings/sms-test).
  basePath: string;
  messages: SmsToolsMessages;
  notify: SmsNotify;
  defaultAccount?: SmsAccount;
}

// Ayarlar > SMS Ayarları'ndaki "Test SMS Gönder" ve "Kalan SMS Adedi" kartlarının
// arayüzden bağımsız mantığı. Görünüm uygulamanın kendi bileşenleriyle çizilir.
export function useSmsTools({ http, basePath, messages, notify, defaultAccount = "OTP" }: UseSmsToolsOptions) {
  const [testPhone, setTestPhone] = useState("");
  const [testAccount, setTestAccount] = useState<SmsAccount>(defaultAccount);
  const [testLoading, setTestLoading] = useState(false);
  const [balance, setBalance] = useState<string | null>(null);
  const [balanceLoading, setBalanceLoading] = useState(false);

  const failText = (err: unknown, fallback: string) => {
    const { message, raw } = errorDetails(err);
    return [message ?? fallback, raw && messages.rawSuffix(raw)].filter(Boolean).join(" ");
  };

  const sendTest = async () => {
    setTestLoading(true);
    try {
      const res = await http.post<{ via?: string }>(`${basePath}/sms-test`, { phone: testPhone, account: testAccount });
      const viaNote = res.data.via === "STANDARD_FALLBACK" ? ` ${messages.testViaFallback}` : "";
      await notify(`${messages.testSent}${viaNote}`, "info");
    } catch (err) {
      await notify(failText(err, messages.testFailed), "danger");
    } finally {
      setTestLoading(false);
    }
  };

  const checkBalance = async () => {
    setBalanceLoading(true);
    try {
      const res = await http.get<{ raw: string }>(`${basePath}/sms-balance`);
      setBalance(res.data.raw);
    } catch (err) {
      setBalance(null);
      await notify(failText(err, messages.balanceFailed), "danger");
    } finally {
      setBalanceLoading(false);
    }
  };

  return {
    testPhone,
    setTestPhone,
    testAccount,
    setTestAccount,
    testLoading,
    sendTest,
    balance,
    balanceLoading,
    checkBalance,
  };
}
